var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"empty-box"},[_vm._m(0),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.emptyText))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/icon/empty.svg")}})])
}]

export { render, staticRenderFns }